import { render } from "./RepairNoteModal.vue?vue&type=template&id=20bb7b48&scoped=true"
import script from "./RepairNoteModal.vue?vue&type=script&lang=js"
export * from "./RepairNoteModal.vue?vue&type=script&lang=js"

import "./RepairNoteModal.vue?vue&type=style&index=0&id=20bb7b48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bb7b48"]])

export default __exports__